import { HttpMethod, RequestOptions, useUserOrKioskRequest } from "../../common/lib/fetch";

export interface ReceivingAcceptGrossWeightResp {
  bayName?: string
}

const useReceivingAcceptGrossWeight = (stagedPurchaseOrderId: string, options: RequestOptions<ReceivingAcceptGrossWeightResp>) =>
  useUserOrKioskRequest<void, ReceivingAcceptGrossWeightResp>({
    method: HttpMethod.POST,
    path: `/api/stagedPurchaseOrders/${stagedPurchaseOrderId}/grossWeight`
  }, options);

export default useReceivingAcceptGrossWeight;
